export default __webpack_public_path__ + "static/form-adf094540aa4636028910782af91aaa0.png";